// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/styles/app.css
// module id = 820
// module chunks = 1